import { cloneDeep } from "lodash";
import { applyPatch } from "rfc6902";
import { ArsContextState, IArsActionRedoChange } from "../interface";
import { extractDataState } from "./arsc_patchHelpers";

/**
 * Moves the undo pointer forward and applies forward patches.
 *
 * @param state - Current ARS context state
 * @param action - Redo action with optional step count
 * @returns Updated state after redo operations
 */
export const arsc_redoArsChange = <T>(
  state: ArsContextState<T>,
  action: IArsActionRedoChange,
): ArsContextState<T> => {
  const steps = action.steps ?? 1;
  const newIx = Math.min(state.patches.length - 1, state.ixPatch + steps);

  if (newIx === state.ixPatch || newIx < 0) {
    return state;
  }

  const currentState = cloneDeep(extractDataState(state));
  for (let i = state.ixPatch + 1; i <= newIx; i++) {
    const patch = state.patches[i];
    /* istanbul ignore else */
    if (patch) {
      applyPatch(currentState, patch.forward);
    }
  }

  return {
    ...state,
    ...currentState,
    ixPatch: newIx,
  };
};
